import { useIxcSweepsV1SweepPlanQueryServiceSweepPlanList } from '@interxfi/api-client/generated/hooks/ixc-sweeps-v1-sweep-plan-query-service-sweep-plan-list';
import {
  IxcSweepsV1SweepPlanQueryServiceSweepPlanListFilterableFields,
  type IxcSweepsV1SweepPlanQueryServiceSweepPlanListSweepPlanListRequest,
  type IxcSweepsV1SweepPlanState,
  type IxcSweepsV1SweepPlanStatus,
} from '@interxfi/types/generated/api';
import { createDataCombobox } from '../data-combobox-builder';

export function getSweepPlanLabel(plan: IxcSweepsV1SweepPlanState): string {
  return plan?.data?.name || plan?.sweepPlanId || 'Unknown Plan';
}

interface BuildSweepPlanQueryParams {
  status?: IxcSweepsV1SweepPlanStatus | IxcSweepsV1SweepPlanStatus[];
  sweepPlanId?: string | string[];
}

export function buildSweepPlanComboboxQuery({
  status,
  sweepPlanId,
}: BuildSweepPlanQueryParams): IxcSweepsV1SweepPlanQueryServiceSweepPlanListSweepPlanListRequest | undefined {
  const hasSweepPlanIdFilter = typeof sweepPlanId === 'string' || (Array.isArray(sweepPlanId) && sweepPlanId.length > 0);
  if (!status && !hasSweepPlanIdFilter) {
    return undefined;
  }

  return {
    query: {
      filters: [
        ...(status
          ? [
              {
                field: {
                  name: IxcSweepsV1SweepPlanQueryServiceSweepPlanListFilterableFields.Status,
                  type: Array.isArray(status) ? { in: { values: status } } : { value: status },
                },
              },
            ]
          : []),
        ...(hasSweepPlanIdFilter
          ? [
              {
                field: {
                  name: IxcSweepsV1SweepPlanQueryServiceSweepPlanListFilterableFields.SweepPlanId,
                  type: Array.isArray(sweepPlanId) ? { in: { values: sweepPlanId } } : { value: sweepPlanId },
                },
              },
            ]
          : []),
      ],
    },
  };
}

export const {
  DataComboboxInput: SweepPlanCombobox,
  DataComboboxInputWithLens: SweepPlanComboboxWithLens,
  DataMultiComboboxInputWithLens: SweepPlanMultiComboboxWithLens,
} = createDataCombobox<typeof useIxcSweepsV1SweepPlanQueryServiceSweepPlanList, 'sweepPlan', 'sweepPlanId'>({
  dataValueKey: 'sweepPlanId',
  entityName: 'sweep plans',
  responseDataKey: 'sweepPlan',
  useInfiniteQuery: useIxcSweepsV1SweepPlanQueryServiceSweepPlanList,
  optionDisplayBuilder: (plan) => ({
    label: getSweepPlanLabel(plan),
  }),
});
